/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BankAccountCell_bankAccount$ref: FragmentReference;
declare export opaque type BankAccountCell_bankAccount$fragmentType: BankAccountCell_bankAccount$ref;
export type BankAccountCell_bankAccount = {|
  +id: string,
  +plaidAccountId: string,
  +mask: ?string,
  +name: ?string,
  +officialName: ?string,
  +accountSubtype: ?string,
  +accountType: ?string,
  +originalBankAccount: ?{|
    +id: string,
    +ownerAuth0Id: string,
    +plaidAccountId: string,
  |},
  +duplicationState: string,
  +availableDuplicationStates: ?$ReadOnlyArray<string>,
  +bankAccountsWithMask: ?$ReadOnlyArray<{|
    +id: string
  |}>,
  +integrationItem: {|
    +institutionName: ?string
  |},
  +$refType: BankAccountCell_bankAccount$ref,
|};
export type BankAccountCell_bankAccount$data = BankAccountCell_bankAccount;
export type BankAccountCell_bankAccount$key = {
  +$data?: BankAccountCell_bankAccount$data,
  +$fragmentRefs: BankAccountCell_bankAccount$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaidAccountId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BankAccountCell_bankAccount",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mask",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "officialName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountSubtype",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BankAccount",
      "kind": "LinkedField",
      "name": "originalBankAccount",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ownerAuth0Id",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duplicationState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableDuplicationStates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BankAccount",
      "kind": "LinkedField",
      "name": "bankAccountsWithMask",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationItem",
      "kind": "LinkedField",
      "name": "integrationItem",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "institutionName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BankAccount"
};
})();
// prettier-ignore
(node/*: any*/).hash = '01376daf8a0b9422759de2a30d5a1249';

module.exports = node;
